var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationConfettiLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 43,
    viewBox: "0 0 64 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2485 16.3687C37.2936 20.3316 42.0789 20.7679 44.677 24.6461L47.6738 20.8406C45.1362 16.8898 40.2905 16.5262 37.2453 12.5632L34.2485 16.3687Z",
    fill: "#80E49F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5706 0.480438L28.9746 3.8844L25.5706 7.28836L22.1667 3.8844L25.5706 0.480438Z",
    fill: "#1D873E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2132 28.6737L25.6172 32.0776L22.2132 35.4816L18.8093 32.0776L22.2132 28.6737Z",
    fill: "#419791"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4431 42.0991C39.7489 42.0991 40.043 41.9815 40.2782 41.7578L42.6306 39.404C43.0893 38.945 43.0893 38.2035 42.6306 37.7445C42.1719 37.2855 41.4309 37.2855 40.9721 37.7445L38.6198 40.0984C38.1611 40.5574 38.1611 41.2988 38.6198 41.7578C38.855 41.9932 39.1491 42.0991 39.4549 42.0991H39.4431Z",
    fill: "#419791"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5818 11.8922C59.8876 11.8922 60.1816 11.7745 60.4169 11.5509L62.7692 9.19708C63.228 8.73807 63.228 7.99661 62.7692 7.53761C62.3105 7.07861 61.5695 7.07861 61.1108 7.53761L58.7584 9.89146C58.2997 10.3505 58.2997 11.0919 58.7584 11.5509C58.9937 11.7863 59.2877 11.8922 59.5935 11.8922H59.5818Z",
    fill: "#419791"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54537 27.3312C3.84963 27.3312 4.16559 27.2113 4.38793 26.9594C4.83261 26.4796 4.82091 25.724 4.35282 25.2682L1.98898 22.9654C1.52089 22.5096 0.783657 22.5216 0.338974 23.0014C-0.10571 23.4811 -0.0940089 24.2368 0.374079 24.6925L2.73792 26.9954C2.96026 27.2113 3.25282 27.3312 3.54537 27.3312Z",
    fill: "#80E49F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationConfettiLeft);
export default __webpack_public_path__ + "static/media/illustration--confetti-left.f9b3e5cf52cb56c2357708ad7e017552.svg";
export { ForwardRef as ReactComponent };